/* global sessionStorage */

export default class SessionService {
  static getItem(name) {
    return JSON.parse(sessionStorage.getItem(name));
  }
  static setItem(name, data) {
    sessionStorage.setItem(name, JSON.stringify(data));
  }
  static removeItem(name) {
    sessionStorage.removeItem(name);
  }
}
